export default __webpack_public_path__ + "static/media/email.0dc92f9a.png";